import React from 'react'
import './new-student-offer-2024.css'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { baseUrl } from "../assets/Animations";

const NewStudentOffer2024 = () => {
    const [gettingTimes, setGettingTimes] = React.useState(true)

    const {familyId, teacherId} = useParams()

    React.useEffect(() => {
        getTeacherInfo()
    }, [])

    const getTeacherInfo = async () => {
        axios.get(`${baseUrl}/teacher-availability/${teacherId}`)
        .then((response) => {
            console.log(response.data)
        })
        .catch((error) => {
            console.log(error)
        })
    }

    return (
        <div>
            <img src='/mmalogo.png' />
            <div>Choose a time</div>
            <div>According to your schedule and availability, these are the top choices:</div>
            <div></div>
            <div>None of these work? <span>Update your availability.</span></div>
            <input placeholder='Anything we should know that will help us schedule you?' />
            <div>
                <div>Submit</div>
            </div>
        </div>
    )
}
export default NewStudentOffer2024